import { render, staticRenderFns } from "./CompanyGroupStats.vue?vue&type=template&id=4abe4b0c&scoped=true"
import script from "./CompanyGroupStats.vue?vue&type=script&lang=js"
export * from "./CompanyGroupStats.vue?vue&type=script&lang=js"
import style0 from "./CompanyGroupStats.vue?vue&type=style&index=0&id=4abe4b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abe4b0c",
  null
  
)

export default component.exports